/**
 * Validates the year.
 */
export const validateYear = (year: string) => {
  const yearNumber = parseInt(year, 10);
  if (Number.isNaN(yearNumber)) {
    throw new Error(`Cannot parse year ${year}.`);
  }
  if (yearNumber < 1900 || yearNumber > 3000) {
    throw new Error(`Invalid year: ${year}.`);
  }

  return year;
};
